import calculateBootResult from 'owa-shared-start/lib/calculateBootResult';
import { createBootReliabilityAriaEvent } from 'owa-shared-start/lib/createBootReliabilityAriaEvent';
import { doErrorRetryRedirect } from 'owa-shared-start/lib/doErrorRetryRedirect';
import { getRetryStrategyFromError } from './getRetryStrategyFromError';
import { getServerErrorDiagnostics } from 'owa-shared-start/lib/getServerErrorDiagnostics';
import { lazyPostSignal } from 'mini-start-analytics';
import { TEN_SECONDS_IN_MS } from 'owa-shared-start/lib/timeConstants';
import type { BootError } from 'owa-shared-start-types';
import type StartConfig from '../types/StartConfig';

export async function onBootError(error: BootError, config: StartConfig) {
    const errorDiagnostics = getServerErrorDiagnostics(error);
    let bootResult = calculateBootResult(error, errorDiagnostics);

    const retryStrategy =
        config.overrideRetryStrategy?.(bootResult) ||
        getRetryStrategyFromError(bootResult, errorDiagnostics.esrc, true /* retryWholeApp */);

    if (retryStrategy) {
        bootResult = 'retry';
    }

    // if we are not retrying, let's do the default time out. If not, let's extend the time out to 10 seconds
    try {
        await lazyPostSignal.importAndExecute(
            createBootReliabilityAriaEvent(bootResult, errorDiagnostics, undefined, error),
            retryStrategy ? undefined : TEN_SECONDS_IN_MS
        );

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const didRetry = retryStrategy && doErrorRetryRedirect(retryStrategy, config as any);
        //Adding this to avoid a patch. The start config interface used in mini currently is one SP upgrade behind bigOWA, so types don't line up.
        //But config is expected to do nothing - should just be optionally chained out. Hence avoiding a patch of owa-shared-start that would remove the config param.

        if (!didRetry) {
            config.handleBootError?.(bootResult, error, errorDiagnostics, config.onFatalBootError);
        }
    } catch (e) {
        // tslint:disable-next-line:no-console
        console.error(e);
    }
}
